import React from 'react';
import { Icon } from '@iconify/react';
import {
  ANNEE_OPTIONS,
  CANAUX_OPTIONS,
  COMMERCIAUX_LUNDI_WINDOW_PRESETS,
  DEFAULT_COMMERCIAUX_LUNDI_CANAUX,
  DEFAULT_COMMERCIAUX_LUNDI_WINDOW_DAYS,
  MOIS_OPTIONS,
  normalizeCommerciauxLundiWindowDays,
} from '../../utils/kkpCronUi';

const KkpCronCommerciauxLundiFilters = ({ filters, onChange }) => {
  const canaux = (filters?.canaux || []).length > 0
    ? filters.canaux
    : DEFAULT_COMMERCIAUX_LUNDI_CANAUX;
  const periodMode = filters?.period_mode === 'custom' ? 'custom' : 'auto';
  const windowDays = normalizeCommerciauxLundiWindowDays(filters?.window_days);
  const showMagSet = canaux.includes('mag') || canaux.includes('set');
  const showWindow = canaux.includes('web') || canaux.includes('newsletter');

  const update = (patch) => {
    onChange({ ...filters, ...patch });
  };

  const toggleCanal = (canalId) => {
    const next = canaux.includes(canalId)
      ? canaux.filter((id) => id !== canalId)
      : [...canaux, canalId];
    if (next.length === 0) return;
    update({ canaux: next });
  };

  const toggleMois = (value) => {
    const current = (filters?.mois || []).map(Number);
    const next = current.includes(value)
      ? current.filter((item) => item !== value)
      : [...current, value].sort((a, b) => a - b);
    update({ mois: next });
  };

  return (
    <div className="admin-cron-filters">
      <div className="admin-cron-filter-section">
        <div className="admin-cron-filter-section__head">
          <span className="admin-cron-filter-section__title">
            <Icon icon="mdi:television-guide" width={18} />
            Supports
          </span>
        </div>
        <div className="d-flex flex-wrap gap-2">
          {CANAUX_OPTIONS.map((canal) => {
            const active = canaux.includes(canal.id);
            return (
              <button
                key={canal.id}
                type="button"
                className="admin-cron-filter-pill admin-cron-filter-pill--canal"
                style={active
                  ? { backgroundColor: canal.color, borderColor: canal.color, color: '#fff' }
                  : {
                    backgroundColor: `${canal.color}14`,
                    borderColor: `${canal.color}66`,
                    color: canal.color,
                  }}
                aria-pressed={active}
                onClick={() => toggleCanal(canal.id)}
              >
                <Icon icon={active ? 'mdi:check-circle' : canal.icon} width={18} />
                {canal.label}
              </button>
            );
          })}
        </div>
      </div>

      {showMagSet && (
        <div className="admin-cron-filter-section">
          <div className="admin-cron-filter-section__head">
            <span className="admin-cron-filter-section__title">
              <Icon icon="mdi:calendar-month-outline" width={18} />
              Période MAG / SET
            </span>
          </div>
          <div className="d-flex flex-wrap gap-2 mb-2">
            <button
              type="button"
              className={`admin-cron-filter-pill ${periodMode === 'auto' ? 'is-active' : ''}`}
              aria-pressed={periodMode === 'auto'}
              onClick={() => update({ period_mode: 'auto' })}
            >
              Automatique
            </button>
            <button
              type="button"
              className={`admin-cron-filter-pill ${periodMode === 'custom' ? 'is-active' : ''}`}
              aria-pressed={periodMode === 'custom'}
              onClick={() => update({ period_mode: 'custom' })}
            >
              Mois précis
            </button>
          </div>
          {periodMode === 'auto' ? (
            <p className="text-sm text-secondary-light mb-0">
              Mois suivant (n+1). Passe à n+2 si le CDF de ce mois est validé, ou si la date butoir d’envoi du mois en cours est dépassée.
            </p>
          ) : (
            <div className="row g-3">
              <div className="col-md-3">
                <label className="form-label mb-1">Année</label>
                <select
                  className="form-select"
                  value={filters?.annee || ''}
                  onChange={(e) => update({ annee: e.target.value ? Number(e.target.value) : '' })}
                >
                  {ANNEE_OPTIONS.map((year) => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-9">
                <div className="admin-cron-filter-section__head">
                  <span className="form-label mb-0">Mois</span>
                  {(filters?.mois || []).length > 0 && (
                    <button
                      type="button"
                      className="btn btn-sm btn-link text-secondary p-0"
                      onClick={() => update({ mois: [] })}
                    >
                      Effacer
                    </button>
                  )}
                </div>
                <div className="d-flex flex-wrap gap-2">
                  {MOIS_OPTIONS.map((mois) => {
                    const active = (filters?.mois || []).map(Number).includes(mois.value);
                    return (
                      <button
                        key={mois.value}
                        type="button"
                        className={`admin-cron-filter-pill ${active ? 'is-active' : ''}`}
                        aria-pressed={active}
                        onClick={() => toggleMois(mois.value)}
                      >
                        {mois.label.substring(0, 3)}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {showWindow && (
        <div className="admin-cron-filter-section admin-cron-filter-section--last">
          <div className="admin-cron-filter-section__head">
            <span className="admin-cron-filter-section__title">
              <Icon icon="mdi:calendar-week" width={18} />
              Fenêtre WEB / Newsletter
            </span>
          </div>
          <div className="d-flex flex-wrap gap-2">
            {COMMERCIAUX_LUNDI_WINDOW_PRESETS.map((days) => (
              <button
                key={days}
                type="button"
                className={`admin-cron-filter-pill ${windowDays === days ? 'is-active' : ''}`}
                aria-pressed={windowDays === days}
                onClick={() => update({ window_days: days })}
              >
                {days} jours
              </button>
            ))}
            {!COMMERCIAUX_LUNDI_WINDOW_PRESETS.includes(windowDays) && (
              <span className="admin-cron-filter-pill is-active">{windowDays} jours</span>
            )}
          </div>
          <div className="d-flex align-items-center gap-2 mt-2">
            <label className="form-label mb-0" htmlFor="commerciaux-window-days">Autre</label>
            <input
              id="commerciaux-window-days"
              className="form-control"
              type="number"
              min={1}
              max={90}
              style={{ maxWidth: '7rem' }}
              value={windowDays}
              onChange={(e) => update({
                window_days: normalizeCommerciauxLundiWindowDays(
                  e.target.value || DEFAULT_COMMERCIAUX_LUNDI_WINDOW_DAYS,
                ),
              })}
            />
            <span className="text-sm text-secondary-light">jours à venir</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default KkpCronCommerciauxLundiFilters;
